import * as m from "./../../dist/es2015/venn.js";
export const am5venn = m;